<!-- Start of Quick search common component -->
  <app-quick-search 
    [DefaultFilterArray]="venueRatesService.defaultFilterArray"
    [QuickSearchFilterArray]="quickFilterArray"
    (updateDefaultArray)="updateDefaultArray($event)"
    (clearQuickSearch)="clearQuickSearch($event)">
  </app-quick-search>
<!-- end of Quick search common component -->

<p-confirmDialog id="venuerateconfirmDialog" [style]="{width: '30vw',minHeight:'100px'}" appendTo="body"
showEffect="fade" focusOnShow="false" styleClass="venue-rate-confirmDialog"></p-confirmDialog>
<!--Filter Code  -->
<div class="col-lg-12 nopadding">
    <app-filter-panel  id="VenueRateFilter" [GridColumns]="columns" [DefaultFilterArray]="venueRatesService.defaultFilterArray"
    (FilterEvent)="FilterApplyFilterEvent($event)">
  </app-filter-panel>
</div>

<!-- Grid Code  -->
<div class="col-lg-12 nopadding">
  @if(venueRatesService.isLoadingResults){
    <div class="example-loading-shade">
    @if(venueRatesService.isLoadingResults){<mat-spinner></mat-spinner>}
    </div>}
    <p-table 
      id="venueRateTable"
      alwaysShowPaginator="true" 
      paginatorPosition="both" 
      showCurrentPageReport="true"
      [value]="venueRatesService.dataset" 
      [columns]="gridColumns" 
      [resizableColumns]="true" 
      columnResizeMode="expand"
      [(selection)]="selectedRow"
      [paginator]="true"
      appendTo="body"
      (onPage)="changePage($event)"
      (onSort)="sort($event)"
      sortMode="multiple"
      [rows]="constantService.DEFAULT_ROWSIZE" 
      [totalRecords]="venueRatesService.totalRecords" 
      [pageLinks]="constantService.DEFAULT_PAGELINKS"
      [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION"  
      [lazy]="true" 
      [scrollable]="true" 
      scrollHeight="60vh"
      styleClass="tableData destinationDetailsTable"
      #dt>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            {{emptytbldatamsg}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for (col of columns; track col;){
          <th id="columns" pResizableColumn [pSortableColumn]="col.field"
            [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
            {{col.header}}
            @if((col.header | lowercase) !== 'action'){
            <p-sortIcon [field]="col.field"></p-sortIcon>}
          </th>}
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="ri" let-ri="rowIndex">
        <tr [pSelectableRow]="row" [pSelectableRowIndex]="ri"
          [ngClass]="(row['action'] | lowercase) == 'd' ? 'ui-widget-deleted-row' : 'ui-widget-NoUpdated-row'">
          @for (col of columns; track col;){
          <td class="ui-resizable-column"
            [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay' : '' ">
            @if(col.header === 'Action'){
            <span>
              <p-button [id]="'ViewBtn'+row['id']" class="pi pi-xxx" or class="fa fa-xxx" matTooltip="View" matTooltipPosition="above"
                appendTo="body" icon="fa fa-xxx fa-eye" (click)="onView(ri,row);"></p-button>
              <p-button [id]="'EditBtn'+row['id']"   class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Edit" matTooltipPosition="above"
                appendTo="body" icon="fa fa-xxx fa-edit" (click)="onEdit(ri,row);"></p-button>
              <p-button [id]="'DeleteBtn'+row['id']"  class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" matTooltipPosition="above"
                appendTo="body" icon="fa fa-xxx fa-trash" (click)="onDelete(ri,row)"></p-button>
            </span>}
              @if(col.header != 'Action'){
             <span>
                {{row[col.field] }}
            </span>}
          </td>}
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorright">
        <button id="btn_add_venue_rates"  type="button" class="pull-left cls-button" matTooltip="Add Venue Rate"  [matTooltipShowDelay]="1000" (click)="onAdd()" class="exportBtn exportAddVenueRate">Add Venue Rate</button>
        <button  [matTooltip]="this.userService.enableFileExport()?
                    'Export':'Export service is disabled'"
                     [matTooltipShowDelay]="1000" id="btn_destination_export" class="exportBtn"
        (click)="exportToCSV()" type="button">Export  <i class="fa fa-download" aria-hidden="true"></i> 
        @if(isExportToCSV){
        <img style="text-align:right" alt="exportToCSV"
        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
        }</button>
        Total Records: {{venueRatesService.dataset.length == 0 ? 0 : venueRatesService.totalRecords}}
      </ng-template>
      <ng-template pTemplate="paginatorleft">
        Showing {{venueRatesService.dataset.length == 0 ? 0 : venueRatesService.startLimit + 1}} to {{venueRatesService.dataset.length
            < venueRatesService.rowcount ? venueRatesService.dataset.length < venueRatesService.startLimit ? venueRatesService.endLimit : venueRatesService.dataset.length : venueRatesService.endLimit}} entries
      </ng-template>
    </p-table>
    <br>
    <br>
  </div>

@if(showDialog){
  <app-add-edit-view-venue-rates [columns]="columns" [showDialog]="showDialog" [mode]="dialogMode" (visibilityChange)="showDialog = $event" [rowData]="selectedRowData"></app-add-edit-view-venue-rates>
}
